import ServiceAgreementMain from '../views/document/service_agreement/ServiceAgreementMain.vue';
import ServiceAgreementList from '../views/document/service_agreement/ServiceAgreementList.vue';
import ServiceAgreementCreate from '../views/document/service_agreement/ServiceAgreementCreate.vue';
import ServiceAgreementUpdate from '../views/document/service_agreement/ServiceAgreementUpdate.vue';
import ServiceAgreementView from '../views/document/service_agreement/ServiceAgreementView.vue';

import PermitMain from '../views/document/permit/PermitMain.vue';
import PermitList from '../views/document/permit/PermitList.vue';
import PermitCreate from '../views/document/permit/PermitCreate.vue';
import PermitUpdate from '../views/document/permit/PermitUpdate.vue';
import PermitView from '../views/document/permit/PermitView.vue';

import MutualTransferAgreementMain from '../views/document/mutual_transfer_agreement/MutualTransferAgreementMain.vue';
import MutualTransferAgreementList from '../views/document/mutual_transfer_agreement/MutualTransferAgreementList.vue';
import MutualTransferAgreementCreate from '../views/document/mutual_transfer_agreement/MutualTransferAgreementCreate.vue';
import MutualTransferAgreementUpdate from '../views/document/mutual_transfer_agreement/MutualTransferAgreementUpdate.vue';
import MutualTransferAgreementView from '../views/document/mutual_transfer_agreement/MutualTransferAgreementView.vue';

export default {
  routes: [{
    path: 'service-agreement', // SpecimenStateList
    name: 'service-agreement',
    component: ServiceAgreementMain,
    children: [
      {
        path: 'list',
        name: 'service-agreement.list',
        component: ServiceAgreementList,
      },
      {
        path: 'create',
        name: 'service-agreement.create',
        component: ServiceAgreementCreate,
      }, {
        path: 'update/:id',
        name: 'service-agreement.edit',
        component: ServiceAgreementUpdate,
      },
      {
        path: 'view/:id',
        name: 'service-agreement.view',
        component: ServiceAgreementView,
      },
    ],
  }, {
    path: 'permit', // SpecimenStateList
    name: 'permit',
    component: PermitMain,
    children: [
      {
        path: 'list',
        name: 'permit.list',
        component: PermitList,
      },
      {
        path: 'create',
        name: 'permit.create',
        component: PermitCreate,
      }, {
        path: 'update/:id',
        name: 'permit.edit',
        component: PermitUpdate,
      },
      {
        path: 'view/:id',
        name: 'permit.view',
        component: PermitView,
      },
    ],
  }, {
    path: 'mutual-transfer-agreement',
    name: 'mutual-transfer-agreement',
    component: MutualTransferAgreementMain,
    children: [
      {
        path: 'list',
        name: 'mutual-transfer-agreement.list',
        component: MutualTransferAgreementList,
      },
      {
        path: 'create',
        name: 'mutual-transfer-agreement.create',
        component: MutualTransferAgreementCreate,
      },
      {
        path: 'update/:id',
        name: 'mutual-transfer-agreement.edit',
        component: MutualTransferAgreementUpdate,
      },
      {
        path: 'update/:id',
        name: 'mutual-transfer-agreement.view',
        component: MutualTransferAgreementView,
      },
    ],
  }],
};
